module.exports = __webpack_public_path__ + "static/media/telephone.a1e2126f.svg";